/*
 * @Author: your name
 * @Date: 2021-05-19 10:16:31
 * @LastEditTime: 2021-05-19 11:32:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zhihui\roses-admin-vue\src\api\home\FlowMonit.js
 */

import Vue from 'vue';
import config from '../../config/index';
export default {
  // 查询列表
  postList(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/mediaRateFlowRecord/page`, params);
  },
  // 导出操作日志
  getExport(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/mediaRateFlowRecord/export`, params, {
      responseType: 'blob'
    });
  }
};
